// extracted by mini-css-extract-plugin
export default {"media-wrapper":"style_media-wrapper__19HQi"};